import { observable, action, makeObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';
import { AllScreens } from '../core-utils/formatters/UserManagementPageFormatter';

export interface EmployerGroup {
  employerName: string;
  egNid: string;
  screens: string[];
}

export class UserDetailsStore {
  allScreens: AllScreens = {
    riskManagement: [],
    complianceAssurance: [],
    careNavigation: [],
  };
  userAccess: boolean = false;
  riskManagement: boolean = false;
  riskManagementGroups: EmployerGroup[] = [];
  complianceAssurance: boolean = false;
  complianceAssuranceGroups: EmployerGroup[] = [];
  careNavigation: boolean = false;
  careNavigationGroups: EmployerGroup[] = [];

  constructor() {
    makeObservable(this, {
      allScreens: observable,
      setAllScreens: action,
      removeAllScreens: action,
      userAccess: observable,
      setUserAccess: action,
      riskManagement: observable,
      riskManagementGroups: observable,
      complianceAssurance: observable,
      complianceAssuranceGroups: observable,
      careNavigation: observable,
      careNavigationGroups: observable,
      setUserAccessData: action,
    });

    makePersistable(this, {
      name: 'UserDetailsStore',
      properties: [
        'allScreens',
        'userAccess',
        'riskManagement',
        'riskManagementGroups',
        'complianceAssurance',
        'complianceAssuranceGroups',
        'careNavigation',
        'careNavigationGroups',
      ],
      storage: window.localStorage,
    });
  }

  setAllScreens(allScreens: AllScreens) {
    this.allScreens = allScreens;
  }

  removeAllScreens() {
    this.allScreens = {
      riskManagement: [],
      complianceAssurance: [],
      careNavigation: [],
    };
  }

  setUserAccessData(data: {
    riskManagement: boolean;
    riskManagementGroups: EmployerGroup[];
    complianceAssurance: boolean;
    complianceAssuranceGroups: EmployerGroup[];
    careNavigation: boolean;
    careNavigationGroups: EmployerGroup[];
  }) {
    this.riskManagement = data.riskManagement;
    this.riskManagementGroups = data.riskManagementGroups;
    this.complianceAssurance = data.complianceAssurance;
    this.complianceAssuranceGroups = data.complianceAssuranceGroups;
    this.careNavigation = data.careNavigation;
    this.careNavigationGroups = data.careNavigationGroups;
  }

  setUserAccess(userAccess: boolean) {
    this.userAccess = userAccess;
  }

  removeUserAccess() {
    this.userAccess = false;
    this.riskManagement = false;
    this.riskManagementGroups = [];
    this.complianceAssurance = false;
    this.complianceAssuranceGroups = [];
    this.careNavigation = false;
    this.careNavigationGroups = [];
  }
}

export default UserDetailsStore;
